import React from 'react'
import cx from 'classnames'

import styles from './TableCell.module.scss'

const BODY = 'body'
const HEAD = 'head'

const CELL_TYPES = {
  [BODY]: 'td',
  [HEAD]: 'th',
}

export const TableCell = ({
  children,
  className = undefined,
  colSpan,
  maxWidth,
  type,
  hasIncreasedHeight = false,
}) => {
  const Cell = CELL_TYPES[type]

  return (
    <Cell
      className={cx(styles.cell, {
        [styles.head]: type === 'head',
        [styles.higher]: hasIncreasedHeight,
        [className]: Boolean(className),
      })}
      colSpan={colSpan}
      style={{ maxWidth }}
    >
      {children}
    </Cell>
  )
}
